import { S } from "../styles";

export function Field({ label, children }) {
  return <div style={{display:"flex",flexDirection:"column",gap:3}}><label style={S.label}>{label}</label>{children}</div>;
}

export function Pill({ label, value, color }) {
  const colors = { gold:"rgba(255,197,67,0.12)", teal:"rgba(49,180,166,0.1)", orange:"rgba(246,134,68,0.12)", default:"rgba(255,255,255,0.04)" };
  const textColors = { gold:"#ffc543", teal:"#31b4a6", orange:"#f68644", default:"#ffffff" };
  const borders = { gold:"rgba(255,197,67,0.3)", teal:"rgba(49,180,166,0.3)", orange:"rgba(246,134,68,0.3)", default:"rgba(255,255,255,0.07)" };
  const c = color || "default";
  return (
    <div style={{ background:colors[c], border:`1px solid ${borders[c]}`, borderRadius:8, padding:"10px 14px", minWidth:130 }}>
      <div style={{ color:"#75788b", fontSize:10, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:3 }}>{label}</div>
      <div style={{ color:textColors[c], fontSize:14, fontWeight:700, fontFamily:"'Poppins',sans-serif" }}>{value}</div>
    </div>
  );
}
